import { render } from "./MobileJoyTouch.vue?vue&type=template&id=5a735252&scoped=true"
import script from "./MobileJoyTouch.vue?vue&type=script&lang=js"
export * from "./MobileJoyTouch.vue?vue&type=script&lang=js"

import "./MobileJoyTouch.vue?vue&type=style&index=0&id=5a735252&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a735252"]])

export default __exports__